import React, { useState, useEffect } from "react";

// third-party
import { FormattedMessage } from "react-intl";
import orderWaPendingCount from "../../Services/orderWaPendingCount";

import { getDecryptDataFromLocal } from "../../utils/encrypt";
import { canAccessShopifyWaInbox } from "../Dashboard/shopifyWaInboxAccess";

// assets
import {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconMail,
    IconCalendar,
    IconNfc,
    IconBuildingStore,
    IconMessageCircle,
} from "@tabler/icons";

// constant
const icons = {
    IconUserCheck: IconUserCheck,
    IconBasket: IconBasket,
    IconMessages: IconMessages,
    IconMail: IconMail,
    IconCalendar: IconCalendar,
    IconNfc: IconNfc,
    IconBuildingStore: IconBuildingStore,
    IconMessageCircle: IconMessageCircle,
};

// My Chats nav appears for:
//   - admins where admins.whatsappAgent === true (stamped on login response)
//   - role 1 (admin/owner) and role 17 (super-manager) — supervisor view (sees ALL chats)
const isWhatsAppAgent = (() => {
  try {
    if (localStorage.getItem('whatsappAgent') === 'true') return true;
    const role = Number(getDecryptDataFromLocal('setRole'));
    return role === 1 || role === 17;
  } catch (e) { return false; }
})();

// Order WA inbox — for admins where orderWaInbox === true in DB
const isOrderWaUser = (() => {
  try { return localStorage.getItem('orderWaInbox') === 'true'; }
  catch (e) { return false; }
})();

const OrderWaBadge = () => {
  const [n, setN] = useState(orderWaPendingCount.current);
  useEffect(() => orderWaPendingCount.subscribe(setN), []);
  if (!n) return <span>Order WA Inbox</span>;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      Order WA Inbox
      <span style={{
        background: '#d32f2f', color: '#fff',
        borderRadius: 10, fontSize: 10, fontWeight: 700,
        padding: '1px 6px', lineHeight: '16px',
        flexShrink: 0,
      }}>
        {n > 99 ? '99+' : n}
      </span>
    </span>
  );
};

//-----------------------|| Customer MENU ITEMS ||-----------------------//

export const MainDashboard = {
    id: "main",
    title: <FormattedMessage id="Dashboard" />,
    type: "group",
    children: [
        {
            id: "Default",
            title: <FormattedMessage id="Dashboard" />,
            type: "item",
            url: "/dashboard/default",
            breadcrumbs: false,

        },
        isWhatsAppAgent && {
            id: "MyChats",
            title: <FormattedMessage id="My Chats" />,
            type: "item",
            url: "/dashboard/my-chats",
            icon: icons["IconMessageCircle"],
            breadcrumbs: false,
        },
        isOrderWaUser && {
            id: "OrderWaInbox",
            title: <OrderWaBadge />,
            type: "item",
            url: "/dashboard/order-wa-inbox",
            icon: icons["IconMessages"],
            breadcrumbs: false,
        },
        // Shopify (clensta.com) website-order WhatsApp number — admins + allowlist
        // in Dashboard/shopifyWaInboxAccess.js.
        canAccessShopifyWaInbox() && {
            id: "ShopifyWaInbox",
            title: <span>🛍️ Shopify WA Inbox</span>,
            type: "item",
            url: "/dashboard/shopify-wa-inbox",
            icon: icons["IconMessages"],
            breadcrumbs: false,
        },
    ].filter(Boolean),
};
